import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "stay_instructions",
    object: "stay_instruction",
    header: [

        { text: "Title", value: "title" },
        { text: "Animación", value: "animation" },
        { text: "Descripción", value: "description" },
        { text: "Acciones", value: "actions", sortable: false, width:"20%" }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
